// ABOUTME: Shared TanStack Query options for portfolio reads
// ABOUTME: Consumers and the route prefetcher spread the same options so keys and fetchers cannot drift

import { type QueryClient, queryOptions } from '@tanstack/react-query';
import { portfolioManagementApi } from '../api-client';

export const portfoliosQueryOptions = queryOptions({
  queryKey: ['portfolios'],
  queryFn: async () => {
    const data = await portfolioManagementApi.list();
    return data.items;
  },
  // Match PortfoliosListPage so the two observers on ['portfolios'] don't
  // force a background refetch against each other on provider remount.
  staleTime: 60_000,
});

export function portfolioEnrichedQueryOptions(id: string | null) {
  return queryOptions({
    queryKey: ['portfolio-enriched', id],
    queryFn: async () => (id ? portfolioManagementApi.getEnriched(id) : null),
    enabled: !!id,
  });
}

export const summaryQueryOptions = queryOptions({
  queryKey: ['portfolios', 'summary'],
  queryFn: async ({ client, signal }) => {
    const startedAt = Date.now();
    const summary = await portfolioManagementApi.getSummary(signal);
    if (signal.aborted) return summary;
    for (const p of summary.portfolios) {
      const key = ['portfolio-enriched', p.id];
      if ((client.getQueryState(key)?.dataUpdatedAt ?? 0) < startedAt) {
        client.setQueryData(key, p);
      }
    }
    return summary;
  },
  staleTime: 30_000,
});

export async function invalidatePortfolioData(
  queryClient: QueryClient,
  portfolioId: string | null
) {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ['portfolio-enriched', portfolioId] }),
    queryClient.invalidateQueries({ queryKey: summaryQueryOptions.queryKey }),
  ]);
}
